module.exports = __webpack_public_path__ + "static/frost_giant_fight_remorhaz-ba62a342b07d81ff0ad40ea2cfff12ea.jpg";